module.exports = __webpack_public_path__ + "MaterialIcons-Regular.woff2?570eb83859dc23dd0eec423a49e147fe";


//////////////////
// WEBPACK FOOTER
// ./client/src/assets/style/icon/MaterialIcons-Regular.woff2
// module id = 270
// module chunks = 0